// extracted by mini-css-extract-plugin
module.exports = {"bread-crumb-last-item":"bread-crumb-mobile_bread-crumb-last-item__pygIx"};